
















import Vue from 'vue';
import { defineComponent, ref, watch, computed } from '@vue/composition-api';

export default defineComponent({
    props: {
        name:   { type: String, required: true },
        value:  { type: Boolean, default: false },
        label:  { type: String, default: '' },
        error:  { type: Object },
    },

    setup(props, context) {

        const id = props.name;

        const wrapperClasses = computed(() => {
            return {
                'wok--form-item': true
            };
        });

        const inputClasses = computed(() => {
            return {
                '': true
            };
        });

        const onChange = (evt: Event) => {
            if (evt.target instanceof HTMLInputElement) {
                context.emit('input', evt.target.checked);
            }
        }

        return {
            id,
            wrapperClasses,
            inputClasses,
            onChange
        }
    }
})
